const fixed = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 99999,
};

export const screen = {
    transition: 'opacity 250ms ease',
    ...fixed,
    width: '100vw',
    height: '100vh',
    overflow: 'hidden',
    bgGradient: 'linear(to-b, primary.800, secondary.default)',
};

export const roadMap = (backgroundUrl) => ({
    opacity: 0.3,
    width: '100vw',
    height: '100vh',
    userSelect: 'none',
    pointerEvents: 'none',
    background: `url('${backgroundUrl}')`,
    backgroundPosition: 'bottom left',
    backgroundRepeat: 'no-repeat',
    backgroundSize: {base: 'cover', tablet: '100%'},
});

export const loading = {
    ...fixed,
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    sx: {
        svg: {
            fill: 'currentColor',
            width: {
                base: 60,
                tablet: 80,
            },
            height: {
                tablet: 80,
            },
        },
    },
};

export const heading = {
    mt: {base: -8, tablet: -12},
    mb: 4,
    fontSize: {base: '2xl', tablet: '4xl'},
};

export const spinner = {
    size: 'lg',
    thickness: 4,
    color: 'white',
    emptyColor: 'gray.dark',
};
